// File: app.component.ts
// Author: Joseph M Diaz
// Date: 4/20/2017
// Desc: Root component for the app.
// Other Contributors: Brandon Shreve

import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { AppService } from './app.service';
import { CgpIdleService } from './shared/cgp-idle/cgp-idle.service';
import { Router } from '@angular/router';
import { getEnv } from '../modules/utility';

@Component({
    selector: 'cgp-app',
    templateUrl: './app.template.html',
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
    public sidenavVisible = false;
    env = '';

    constructor(
        private readonly router: Router,
        public appService: AppService,
        private readonly cgpIdleService: CgpIdleService,
    ) {
        this.appService.appComponent = this;
        this.cgpIdleService.startTimers();
    }

    ngOnInit() {
        this.env = getEnv().toLowerCase();

    }


    @HostListener('window:mousemove')
    onMouseMove() {
        this.cgpIdleService.setIsActive();
    }

    @HostListener('window:mousedown')
    onMouseDown() {
        this.cgpIdleService.setIsActive();
    }

    @HostListener('window:keydown')
    onKeyDown() {
        this.cgpIdleService.setIsActive();
    }
}
